const streamdata = [
    {
        "Raoul": 42,
        "Josiane": 166,
        "Marcel": 127,
        "René": 186,
        "Paul": 168,
        "Jacques": 126
    },
    {
        "Raoul": 82,
        "Josiane": 68,
        "Marcel": 176,
        "René": 20,
        "Paul": 74,
        "Jacques": 32
    },
    {
        "Raoul": 90,
        "Josiane": 169,
        "Marcel": 80,
        "René": 142,
        "Paul": 49,
        "Jacques": 118
    },
    {
        "Raoul": 135,
        "Josiane": 192,
        "Marcel": 131,
        "René": 42,
        "Paul": 104,
        "Jacques": 20
    },
    {
        "Raoul": 187,
        "Josiane": 193,
        "Marcel": 164,
        "René": 85,
        "Paul": 47,
        "Jacques": 52
    },
    {
        "Raoul": 131,
        "Josiane": 34,
        "Marcel": 197,
        "René": 176,
        "Paul": 196,
        "Jacques": 58
    },
    {
        "Raoul": 67,
        "Josiane": 128,
        "Marcel": 129,
        "René": 24,
        "Paul": 43,
        "Jacques": 54
    },
    {
        "Raoul": 128,
        "Josiane": 92,
        "Marcel": 178,
        "René": 57,
        "Paul": 108,
        "Jacques": 10
    },
    {
        "Raoul": 65,
        "Josiane": 95,
        "Marcel": 65,
        "René": 98,
        "Paul": 21,
        "Jacques": 49
    }
]
export default streamdata;